import { useState } from "react";
import { BookMarked, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";
import { euro } from "@/lib/format";

// Searchable picker for the (potentially thousands) preziario voci across all books.
export default function PreziarioPicker({ items = [], onPick }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const term = search.toLowerCase();
  const filtered = (term
    ? items.filter((p) => `${p.codice} ${p.nome}`.toLowerCase().includes(term))
    : items
  ).slice(0, 60);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="h-9 text-xs justify-start font-normal text-muted-foreground" data-testid="quote-preziario-picker">
          <BookMarked className="w-3.5 h-3.5 mr-1.5 text-primary" />
          {items.length ? "Da preziario…" : "Preziario vuoto"}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[380px]" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Cerca voce o codice…" value={search} onValueChange={setSearch} />
          <CommandList>
            <CommandEmpty>{items.length ? "Nessuna voce trovata." : "Importa prima un preziario."}</CommandEmpty>
            <CommandGroup>
              {filtered.map((p) => (
                <CommandItem
                  key={p.id}
                  value={p.id}
                  onSelect={() => { onPick(p); setOpen(false); setSearch(""); }}
                  className="flex items-start gap-2"
                >
                  <Check className="w-3.5 h-3.5 mt-0.5 opacity-0" />
                  <div className="flex-1 min-w-0">
                    <div className="text-xs font-medium truncate">{p.codice ? `${p.codice} · ` : ""}{p.nome}</div>
                    <div className="text-[11px] text-muted-foreground">{p.preziario_nome ? `${p.preziario_nome} · ` : ""}{p.unita} · <span className="text-primary font-semibold">{euro(p.prezzo_finale)}</span></div>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
